import { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { Piko } from '../components/Piko';
import { audio } from '../core/audio';
import { getState } from '../core/storage';
import { t, lang } from '../core/i18n';
import { MISSIONS } from '../content/missions';

const ACT_TEXT = {
  act_head: ['Sentuh kepala', 'Touch your head', '🙆'],
  act_clap: ['Tepuk tangan dua kali', 'Clap twice', '👏'],
  act_knees: ['Sentuh lutut', 'Touch your knees', '🧎'],
  act_wave: ['Lambai tangan', 'Wave your hand', '👋'],
  act_stand: ['Berdiri', 'Stand up', '🧍'],
  act_sit: ['Duduk', 'Sit down', '🪑'],
};

// Piko Says + Two-Step Mission: voice-led physical actions, parent confirms.
export function ActionMission({ activity, onComplete }) {
  const en = lang() === 'en';
  const twoStep = useMemo(() => {
    if (!activity.twoStep) return null;
    const pool = MISSIONS.filter((m) => m.type !== 'family');
    const a = pool[Math.floor(Math.random() * pool.length)];
    let b = a;
    while (b.id === a.id) b = pool[Math.floor(Math.random() * pool.length)];
    return [a, b];
  }, [activity.id]); // eslint-disable-line
  const [step, setStep] = useState(0);
  const steps = twoStep ? twoStep.map((m) => ({ text: [m.ms, m.en], icon: '⭐' }))
    : activity.actions.map((a) => ({ text: [ACT_TEXT[a.id][0], ACT_TEXT[a.id][1]], icon: ACT_TEXT[a.id][2], voice: a.id }));

  useEffect(() => {
    (async () => {
      await audio.playVoice(activity.voice);
      if (steps[0]?.voice) await audio.playVoice(steps[0].voice);
    })();
  }, [activity.id]); // eslint-disable-line

  const confirm = async () => {
    audio.playSfx('correct');
    if (step + 1 < steps.length) {
      const ns = step + 1;
      setStep(ns);
      if (steps[ns].voice) await audio.playVoice(steps[ns].voice);
    } else {
      await audio.playVoice('correct1');
      onComplete({ correct: true, attempts: 1, hints: 0 });
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-6 px-6" data-testid="activity-action-mission">
      <Piko pose="point" size={120} />
      <div className="bg-white/90 backdrop-blur-xl rounded-[2rem] p-6 shadow-lg text-center max-w-sm w-full" data-testid="action-card">
        <div className="flex justify-center gap-2 mb-2">
          {steps.map((_, i) => <div key={i} className={`w-3 h-3 rounded-full ${i < step ? 'bg-leaf' : i === step ? 'bg-sunshine' : 'bg-navy/15'}`} />)}
        </div>
        <div className="text-5xl">{steps[step].icon}</div>
        <p className="font-heading text-2xl font-bold text-navy mt-2">{steps[step].text[en ? 1 : 0]}</p>
        {getState().profile.bilingual && <p className="font-body text-navy/60 mt-1">{steps[step].text[en ? 0 : 1]}</p>}
        <p className="font-body text-navy/45 text-xs mt-3">{en ? 'Parent confirms when done' : 'Ibu/ayah sahkan bila selesai'}</p>
      </div>
      <motion.button whileTap={{ scale: 0.94 }} data-testid="action-done-btn" onClick={confirm}
        className="min-h-[70px] px-10 rounded-[2rem] font-heading font-bold text-2xl text-navy"
        style={{ background: '#4ADE80', boxShadow: 'inset 0 -8px 0 rgba(0,0,0,0.14), 0 10px 22px rgba(74,222,128,0.4)' }}>
        {t('missionDone')}
      </motion.button>
    </div>
  );
}
